<template>
  <layout>
    <div id="loading-screen" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <div v-else>
      <b-row class="pl-3">
        <button type="button" class="btn btn-success" @click="navigate()">
          <i class="icon-plus" />
          Add new member
        </button>
      </b-row>
      <br />
      <b-card>
        <b-row>
          <b-col>
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type name to Search"
                type="text"
                @keyup="seachbyName()"
                title="Type in a name"
              />
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group>
              <b-form-input
                v-model="filterNIC"
                placeholder="Type NIC to Search"
                type="text"
                @keyup="seachbyNIC()"
                title="Type in a name"
              />
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group>
              <b-form-input
                v-model="filterBarcode"
                placeholder="Type/Scan Barcode"
                type="number"
                @keyup="seachbyBarcode()"
                title="Type in a name"
              />
            </b-input-group>
          </b-col>
        </b-row>

        <br />

        <div>
          <table class="table table-striped table-hover" id="TableList">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Barcode</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">NIC</th>
                <!-- <th scope="col">Mobile No.</th>
                <th scope="col">Mobile No. 2</th> -->
                <!-- <th scope="col">Address</th> -->
                <th scope="col">Last Payment Date</th>
                <th scope="col">Next Payment Date</th>
                <!-- <th scope="col">Joined Date</th> -->
                <th scope="col">Status</th>
                <th scope="col">Options</th>
              </tr>
            </thead>
            <tbody style="height: 100px !important; overflow-y: auto">
              <tr v-for="(member, index) in members" :key="member._id">
                <td>
                  {{ member.barcode == undefined ? '-' : member.barcode }}
                </td>

                <td>{{ member.first_name }}</td>
                <td>{{ member.last_name }}</td>
                <td>{{ member.nic_no }}</td>
                <!-- <td>{{ member.mobile_no }}</td>
                <td>{{ member.mobile_no_2 }}</td> -->
                <!-- <td>{{ member.address }}</td> -->

                <td>{{ member.last_payment_date }}</td>
                <td
                  :class="
                    new Date(member.next_payment_date) > new Date() // Convert string to Date object for comparison
                      ? 'ispaidcss'
                      : 'isUnpaidcss'
                  "
                >
                  {{ member.next_payment_date }}
                </td>

                <!-- <td>{{ member.joined_date }}</td> -->
                <td>{{ member.status }}</td>
                <td>
                  <b-button
                    :key="member._id"
                    class="btn btn-info btn-md"
                    @click="editMember(member)"
                  >
                    <i class="cui-pencil" />
                    Edit
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </div>
  </layout>
</template>

<script>
import Layout from '@layouts/main'
import { memberMethods } from '@state/helpers'

export default {
  name: 'listPrinter',
  components: {
    Layout,
  },
  page: {
    title: 'List Printer',
  },
  data() {
    return {
      members: [],
      filter: null,
      filterNIC: null,
      filterBarcode: null,
      isLoading: false,
    }
  },
  computed: {},
  watch: {},
  async mounted() {
    await this.loadMembers()

    console.log(
      'Next Payment Date:',
      new Date(this.members[0].next_payment_date)
    )
    console.log('Current Date:', new Date())
  },
  methods: {
    ...memberMethods,
    async loadMembers() {
      debugger
      this.isLoading = true
      let response = await this.getAllMembers()
      debugger
      if (response.docs.length > 0) {
        this.members = response.docs
        this.loadGroups()
      } else {
        // notify to create a company first
      }
      this.isLoading = false
    },
    navigate() {
      this.$router.push('/newmember')
    },
    editMember(member) {
      this.$router.push({
        name: 'editMember',
        params: { memberDetails: member },
      })
    },
    seachbyName() {
      debugger
      var input, filter, table, tr, td, i, txtValue

      filter = this.filter.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[1]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    seachbyNIC() {
      var input, filter, table, tr, td, i, txtValue
      filter = this.filterNIC.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[3]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    seachbyBarcode() {
      var input, filter, table, tr, td, i, txtValue
      filter = this.filterBarcode
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[0]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    async loadGroups() {},
  },
}
</script>

<style >
#loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 10px solid #f3f3f3;
  border-top: 10px solid #ecc22e;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ispaidcss {
  color: green !important;
}

.isUnpaidcss {
  color: red !important;
}
</style>
